import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import { COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE } from '../../constants';

import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ONBOARDING_TEMPLATES_RESOURCE,
      method: 'get',
      request: (communityId, t) => ({
        url: addParametersToUri(apiRoutes.onboardingTemplates(), { communityId }),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getOnboardingTemplatesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
